import { VideoPlayer } from 'components/VideoPlayer/VideoPlayer';
import './VideoLesson.scss';

type VideoLessonProps = {
  title: string;
  videoId: string;
};

export const VideoLesson = ({ title, videoId }: VideoLessonProps) => {
  const videoUrl = `//www.youtube.com/embed/${videoId}?autoplay=0&amp;rel=0&amp;fs=1&enablejsapi=1&playerapiid=player&amp;wmode=opaque&amp;hl=en_US&amp;cc_lang_pref=en_US`;
  return (
    <div className='video-content'>
      <VideoPlayer
        url={videoUrl}
        title={title}
        allowedFeatures='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen'
        customStyles={{ width: 790, height: 440 }}
      />
    </div>
  );
};
